export default __webpack_public_path__ + "static/media/rabbit-gun-1.8d311b9f.png";